import React from "react";
import { Sparkles } from "lucide-react";
import type { SlashCommand } from "../types";

interface EmptyStateProps {
  suggestions?: SlashCommand[];
  onSuggestionClick?: (cmd: SlashCommand) => void;
}

export function EmptyState({ suggestions = [], onSuggestionClick }: EmptyStateProps) {
  const topSuggestions = suggestions.slice(0, 4);

  return (
    <div className="flex-1 flex flex-col items-center justify-center px-5 relative z-[1]">
      {/* Animated avatar */}
      <div className="w-16 h-16 cai-avatar-lg rounded-full mb-6" />

      {/* Greeting */}
      <h2 className="text-[20px] font-bold text-text-primary text-center leading-snug tracking-tight mb-1">
        What can I do for you?
      </h2>
      <p className="text-[12px] text-text-secondary text-center leading-relaxed mb-8">
        Ask anything or pick a prompt to get started
      </p>

      {/* Suggestion cards */}
      {topSuggestions.length > 0 && (
        <div className="w-full grid grid-cols-2 gap-2">
          {topSuggestions.map((cmd, i) => (
            <button
              key={cmd.name}
              onClick={() => onSuggestionClick?.(cmd)}
              className="cai-gradient-border text-left px-3 py-3 hover:scale-[1.02] transition-all group cai-fade-up"
              style={{ animationDelay: `${i * 80}ms`, opacity: 0 }}
            >
              <div className="flex items-center gap-1.5 mb-1">
                <Sparkles size={10} className="text-accent-violet" />
                <span className="text-[9px] font-semibold text-accent-violet uppercase tracking-wider">
                  {cmd.name.replace("/", "")}
                </span>
              </div>
              <div className="text-[11px] text-text-secondary group-hover:text-text-primary leading-snug transition-colors">
                {cmd.description}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
